export { default } from './CustomerResetPassword'


// WEBPACK FOOTER //
// ./src/scenes/CustomerResetPassword/index.js